// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3mkja","header":"ClearentDisclaimer_header__sXiKE","inner":"ClearentDisclaimer_inner__3ML6k"};